import React from 'react';
import { Box, Button, Divider, TextButton } from '@wix/design-system';
import { CampaignData } from './CampaignData';
import { reuseCampaign } from './interactions';
export const TOP_CAMPAIGNS_WIDGET = 'TOP_CAMPAIGNS_WIDGET';
export const TopCampaignsWidget = _ref => {
  let {
    data: {
      campaigns
    },
    context: {
      send
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2
  }, campaigns.map(campaign => {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: 2,
      key: campaign.campaignId
    }, /*#__PURE__*/React.createElement(CampaignData, campaign), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
      size: "tiny",
      priority: "secondary",
      onClick: () => reuseCampaign(campaign.campaignId)
    }, "Reuse")), /*#__PURE__*/React.createElement(Box, {
      marginTop: 1
    }, /*#__PURE__*/React.createElement(Divider, null)));
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    onClick: () => send('Show more')
  }, "Show more")));
};
//# sourceMappingURL=TopCampaignsWidget.js.map